const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-notes-preview/artifacts/qfix72o2_Lumero_Logo_transparent_with_name-removebg-preview.png";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="py-12 md:py-16 border-t border-[#1A1B1A]/[0.06]"
      style={{ backgroundColor: "#FAF9F6" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-3">
            <a href="/" data-testid="footer-logo-link">
              <img
                src={LOGO_URL}
                alt="LumeroFlow"
                className="h-7 w-auto"
                data-testid="footer-logo-img"
              />
            </a>
            <p className="text-xs text-[#757675]">
              LumeroFlow is a product by Lumero.
            </p>
          </div>

          <div className="flex items-center gap-8">
            <a
              href="#features"
              data-testid="footer-features-link"
              className="text-sm text-[#4A4B4A] hover:text-[#1A1B1A] transition-colors"
            >
              Features
            </a>
            <a
              href="#how-it-works"
              data-testid="footer-how-link"
              className="text-sm text-[#4A4B4A] hover:text-[#1A1B1A] transition-colors"
            >
              How it works
            </a>
            <a
              href="#pricing"
              data-testid="footer-pricing-link"
              className="text-sm text-[#4A4B4A] hover:text-[#1A1B1A] transition-colors"
            >
              Pricing
            </a>
            <a
              href="#why-lumeroflow"
              data-testid="footer-why-link"
              className="text-sm text-[#4A4B4A] hover:text-[#1A1B1A] transition-colors"
            >
              Why us
            </a>
            <a
              href="/app/login"
              data-testid="footer-login-link"
              className="text-sm text-[#205B5A] hover:text-[#174544] transition-colors font-medium"
            >
              Log in
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
